import styled from 'styled-components'

export const RememberCompleteMedicalRecordModalContainer = styled.div``

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  p {
    line-height: 22px;
  }

  strong {
    color: #1F35B5;
  }
`

export const Separator = styled.div`
  margin: 39px 0;

  height: 1px;
  background: #E2E2E2;

  display: flex;
  align-items: center;
  justify-content: center;

  span {
    padding: 0 10px;
    background: #fff;
  }
`

export const ContentTop = styled.div`
  button {
    margin-top: 30px;
    width: 100%;
  }
`

export const ContentBottom = styled.div`
  button {
    margin-bottom: 10px;
    width: 100%;
  }

  strong:first-child {
    color: #FC4949;
  }
`